import { Component, Input } from '@angular/core';
import { DynamicProperties, AgentDto } from '../../../../../../service/dto';

@Component({
  selector: 'app-agent-view-details',
  standalone: false,
  templateUrl: './agent-view-details.component.html',
  styleUrl: './agent-view-details.component.scss'
})
export class AgentViewDetailsComponent {
	@Input() agent!: AgentDto;

	getDynamicProperties(properties: DynamicProperties): string[]{
		return Object.keys(this.agent.properties);
	}
}
